export enum ProviderInvoiceOrderActions {
  validate = 'VALIDATE'
}
